import * as React from 'react';
import styled, { css } from 'styled-components';

interface IProps {
  className?: string;
  title: string;
  icon: string; 
  negative?: boolean;
  positive?: boolean;
  color?: string;
  onClick: () => void;
  label?: string;
}

const TinyButtonBase = (props: IProps) =>
  <div className={props.className}>
    <div title={props.title} onClick={props.onClick}>
      <svg><use xlinkHref={props.icon}></use></svg>
    </div> 
    <span title={props.label}>{props.label}</span>
  </div>

const TinyButton = styled(TinyButtonBase)`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    flex: 1;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  & > div {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }

  svg {
    width: 16px;
    height: 16px;    
    box-sizing: border-box;
    padding: 2px;
    border-radius: 50%;

    fill: ${p => p.theme.colors.neutral[100]};
    background-color: ${p => p.theme.colors.primary[1]};
    ${p => p.positive && css`background-color: ${p.theme.colors.positive};`}
    ${p => p.negative && css`background-color: ${p.theme.colors.negative};`}
    ${p => p.color    && css`background-color: ${p.color};`}
  }
`
  
export { TinyButton }
